import React from 'react';

const QuestionsContainerTitleBar = () => {
	return (
		<div className="text-sm font-medium dark:text-[#E5FFFF] px-[10px] py-[6px] dark:bg-[#111E2C] flex sm:hidden">
			<div className="min-w-[200px]">Questions</div>
			<div className="min-w-[60px]">Score</div>
			<div className="min-w-[100px]">Time taken</div>
			<div className="grow-2">Skills assessed</div>
			<div className="min-w-[46px]">Details</div>
		</div>
	);
};

export default QuestionsContainerTitleBar;
